export default "__VITE_ASSET__77526822__"